import i18n from "../i18n";
import { Button } from "@mantine/core";
import { useServerApi } from "../hooks/userServerApi";
import { showNotification } from "@mantine/notifications";
import { useState } from "react";
import { IconDownload } from "@tabler/icons";

const ClientPolicyReviewButton = ({ mainForm }) => {
  const [api] = useServerApi();
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = async () => {
    try {
      const id = mainForm?.values._id;
      if (!id) return;
      setIsLoading(true);

      const result = await api.Client.getPolicyReviewReport(id);
      if (!result?.success) throw result;

      const url = result.data?.url;
      if (url) window.open(url, "_blank");
    } catch (error) {
      console.log(error);
      showNotification({
        title: "Error",
        message: error.message || "Failed to download policy review report",
        color: "red",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      fullWidth
      color="teal"
      loading={isLoading}
      leftIcon={<IconDownload size={16} />}
      onClick={handleDownload}
    >{i18n.t("Policy Review")}</Button>
  );
};

export default ClientPolicyReviewButton;
